import { createContext } from 'react'

import { type getTasksQueryKey } from 'components/hooks/tasks/useGetTasks'

export type TasksContextType = {
  getTasksQueryKey: ReturnType<typeof getTasksQueryKey>
}

const TasksContext = createContext<TasksContextType>({
  getTasksQueryKey: [],
})

export default TasksContext
